import { extractApiErrorMessage } from '../../utils/extractApiErrorMessage';

// Of save, run, resume and preview only a 422 is customer-worded; a 403 is "not allowed to …Policy#run?" or "Your roles…".
const isCustomerSafeRefusal = (status: number): boolean => status === 422;

/** The words for a refused schedule call: the api's own for a 422, the fallback for any other status. */
export const refusalMessage = (
  error: Parameters<typeof extractApiErrorMessage>[0],
  fallback: string,
  noResponseMessage?: string
): string => {
  const status = error?.errorResponse?.response?.status;
  // Nothing came back, so axios's words are what tell this from a refusal, unless the caller has words of its own.
  if (!status) return noResponseMessage ?? (error?.message || fallback);

  return isCustomerSafeRefusal(status) ? extractApiErrorMessage(error, fallback) : fallback;
};
